import { DOCUMENT, isPlatformBrowser, Location } from '@angular/common';
import {
    Component,
    Inject,
    OnInit,
    OnDestroy,
    PLATFORM_ID,
    TemplateRef,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// ** rxjs
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
// ** service
import { LayoutService } from './core/services/layout.service';
import { LanguageService } from './core/services/language.service';
//  ** env
import { environment } from '@env/environment';
import * as AOS from 'aos';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    isBrowser = false;
    public loadingTemplate!: TemplateRef<any>;
    private readonly _destroying$ = new Subject<void>();

    constructor(
        public location: Location,
        private primengConfig: PrimeNGConfig,
        private router: Router,
        private titleService: Title,
        public layoutService: LayoutService,
        private languageService: LanguageService,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser)
            window.addEventListener('scroll', e => this.onWindowScroll(e));
        this.titleDynamic();
        
        // 初始化語系
        this.languageService.setInitState();
    }

    onWindowScroll(e) {
        if (window.scrollY > 30) {
            const element = this.document.getElementById('navbar-top');
            if (element) {
                element?.classList.remove('navbar-transparent');
                element?.classList.add('bg-blue');
            }
        } else {
            const element = this.document.getElementById('navbar-top');
            if (element) {
                element?.classList.add('navbar-transparent');
                element?.classList.remove('bg-blue');
            }
        }
    }
    ngOnInit() {
        this.primengConfig.ripple = false;
        
        // 監聽語系變更事件
        this.translateService.onLangChange.pipe(
            takeUntil(this._destroying$)
        ).subscribe((event: LangChangeEvent) => {
            this.updatePrimeNGTranslation(event.lang);
        });

        this.updatePrimeNGTranslation(this.languageService.getCurrentLang());
    }

    ngAfterViewInit() {
        if (!this.isBrowser) return;
        
        setTimeout(() => {
          AOS.init();
        }, 0);
    }

    private updatePrimeNGTranslation(lang: string) {
        if (lang === 'zh-tw') {
            this.primengConfig.setTranslation({
            accept: '確認',
            reject: '取消',
            dayNames: ['日', '一', '二', '三', '四', '五', '六'],
            dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
            dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
            monthNames: [
                '一月',
                '二月',
                '三月',
                '四月',
                '五月',
                '六月',
                '七月',
                '八月',
                '九月',
                '十月',
                '十一月',
                '十二月',
            ],
            monthNamesShort: [
                '一月',
                '二月',
                '三月',
                '四月',
                '五月',
                '六月',
                '七月',
                '八月',
                '九月',
                '十月',
                '十一月',
                '十二月',
            ],
            today: '今天',
            clear: '清除',
            weekHeader: 'Wk',
            // 參數
            // startsWith: 'Starts with',
            // contains: 'Contains',
            // notContains: 'Not contains',
            // endsWith: 'Ends with',
            // equals: 'Equals',
            // notEquals: 'Not equals',
            // noFilter: 'No Filter',
            // lt: 'Less than',
            // lte: 'Less than or equal to',
            // gt: 'Greater than',
            // gte: 'Greater than or equal to',
            // is: 'Is',
            // isNot: 'Is not',
            // before: 'Before',
            // after: 'After',
            // dateIs: 'Date is',
            // dateIsNot: 'Date is not',
            // dateBefore: 'Date is before',
            // dateAfter: 'Date is after',
            // clear: 'Clear',
            // apply: 'Apply',
            // matchAll: 'Match All',
            // matchAny: 'Match Any',
            // addRule: 'Add Rule',
            // removeRule: 'Remove Rule',
            // accept: 'Yes',
            // reject: 'No',
            // choose: 'Choose',
            // upload: 'Upload',
            // cancel: 'Cancel',
            // dayNames: [
            // 	'Sunday',
            // 	'Monday',
            // 	'Tuesday',
            // 	'Wednesday',
            // 	'Thursday',
            // 	'Friday',
            // 	'Saturday',
            // ],
            // dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            // dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            // monthNames: [
            // 	'January',
            // 	'February',
            // 	'March',
            // 	'April',
            // 	'May',
            // 	'June',
            // 	'July',
            // 	'August',
            // 	'September',
            // 	'October',
            // 	'November',
            // 	'December',
            // ],
            // monthNamesShort: [
            // 	'Jan',
            // 	'Feb',
            // 	'Mar',
            // 	'Apr',
            // 	'May',
            // 	'Jun',
            // 	'Jul',
            // 	'Aug',
            // 	'Sep',
            // 	'Oct',
            // 	'Nov',
            // 	'Dec',
            // ],
            // dateFormat: 'mm/dd/yy',
            // firstDayOfWeek: 0,
            // today: 'Today',
            // weekHeader: 'Wk',
            // weak: 'Weak',
            // medium: 'Medium',
            // strong: 'Strong',
            // passwordPrompt: 'Enter a password',
            // emptyMessage: 'No results found',
            // emptyFilterMessage: 'No results found',
            });
        } else {
            this.primengConfig.setTranslation({
                accept: 'Yes',
                reject: 'No',
                dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                monthNames: [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ],
                monthNamesShort: [
                    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                ],
                today: 'Today',
                clear: 'Clear',
                weekHeader: 'Wk',
            });
        }
    }

    ngOnDestroy() {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }

	titleDynamic() {
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				map(() => {
					let route: ActivatedRoute = this.router.routerState.root;
					let routeTitle = '';
					while (route!.firstChild) route = route.firstChild;
					if (route.snapshot.data['title'])
						routeTitle = route!.snapshot.data['title'];
					return routeTitle;
				}),
				takeUntil(this._destroying$),
			)
			.subscribe((title: string) => {
				if (title)
					this.titleService.setTitle(
						`${environment.projectTitleCH} - ${title}`,
					);

				if (this.isBrowser) {
					setTimeout(() => {
						window.scrollTo(0, 0);
					}, 100);
				}
			});
	}
}
